import React from 'react';
import { useCluster } from 'src/features/cluster';
import useOneWayInVMA from '../hooks/use-one-way-in-vma';
import '../styles/OneWayInStyle.scss';
import OneWayInReviewOpportunities from '../components/review/OneWayInReviewOpportunities';
import useOneWayInList from '../hooks/use-one-way-in-list';
import { OpportunityType } from 'src/api/v2';

const OneWayInActorOpportunities: React.FC = () => {
  const { cluster } = useCluster();

  const actorName = cluster!.oneWayInVmaNames.toString();

  const [orderFromOldToNew, setOrderFromOldToNew] = React.useState<boolean>(false);
  const [fromDate, setFromDate] = React.useState<Date | undefined>(undefined);
  const [toDate, setToDate] = React.useState<Date | undefined>(undefined);

  const { oneWayInAllVMAFormsQuery, oneWayInFeedbackListFromActorQuery } = useOneWayInVMA(
    actorName,
    orderFromOldToNew,
    fromDate,
    toDate,
  );

  const { oneWayInAllSavedFormsQuery } = useOneWayInList();

  const greenPlatformOpportunities = oneWayInAllSavedFormsQuery.data?.filter(
    (form) => form.opportunityType === OpportunityType.GreenPlatform,
  );

  return (
    <OneWayInReviewOpportunities
      listQuery={oneWayInAllVMAFormsQuery}
      greenPlatformOpportunities={greenPlatformOpportunities}
      feedbackListQuery={oneWayInFeedbackListFromActorQuery}
      fromList={[]}
      setFromDate={setFromDate}
      setToDate={setToDate}
      orderFromOldToNew={{ init: orderFromOldToNew, set: setOrderFromOldToNew }}
    />
  );
};

export default OneWayInActorOpportunities;
